import actions from '@/vuex/modules/advertiser/report/IntervalReport/actions'
import getters from '@/vuex/modules/advertiser/report/IntervalReport/getters'
import mutations from '@/vuex/modules/advertiser/report/IntervalReport/mutations'

const state = {
  keyword: '',
  advertiserId: 0,
  pageNo: 1,
  intervalReport: {},
  insertionOrderSearchKeyword: '',
  loading: false,
}

const intervalReport = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default intervalReport
